import withTheme from 'core/hocs/withTheme';

import themePropTypes from 'core/utils/prop-types/theme';

import Indent from './Indent';


function SideIndent(props) {
  const {
    children,
    theme: {
      layout: {
        indents,
      },
    },
  } = props;

  return (
    <Indent
      left={indents.left}
      right={indents.right}
    >
      {children}
    </Indent>
  );
}

SideIndent.propTypes = {
  /** @ignore */
  theme: themePropTypes(`{
    layout: {
      indents: {
        left, right
      }
    },
  }`),
};

const SideIndentWithHOC = withTheme(SideIndent);
SideIndentWithHOC.displayName = 'SideIndent';

export default SideIndentWithHOC;
